export default __webpack_public_path__ + "static/media/YAS0240.34I-28863_-16878_0.f168aa4b.jpg";